<template>
  <div>
    <el-row :type="'flex'" :gutter="8" style="min-height: 200px;">
      <el-col :span="16" class="expanded-view">
        <div class="rules-container">
          <el-row :type="'flex'" style="flex-direction: column;">
            <el-col class="subtitle2 bold nowrap rules-heading" :span="4">Rules: ({{countText}})</el-col>
            <el-col class="subtitle2" :span="20" v-if="details.allRules"> <span> All Rules</span></el-col>
            <el-col class="subtitle2 rules-list" :span="20" v-else>
              <span class="display-block text-ellipsis" v-for="(selrule, idx) in visibleRules" :key="idx">
                <span v-if="getRule(selrule)"> {{ selrule }}: {{ getRule(selrule).name }} </span>
                <span v-else>{{ selrule }}</span>
              </span>
            </el-col>
            <el-col v-if="details.rules.length > initialVisibleCount">
              <el-button type="text text-btn" @click="showAllRules = !showAllRules">
                {{showAllRules ? "Hide" : "see all selected"}}
              </el-button>
            </el-col>
          </el-row>
        </div>
        <div class="mr-99">
          <el-row :type="'flex'" style="flex-direction: column;">
            <el-col class="subtitle2 conditions-heading" :span="4">Conditions</el-col>
            <el-col class="subtitle2 conditions-list" :span="20">
              <p class="m-0" v-for="(condition, index) in details.conditions" :key="index">
                <span v-if="index !== 0 && condition.values.length">and</span>
                <span v-if="condition.values.length">
                  {{ condition.level }} event.{{ condition.attribute }} {{ condition.operator }}
                  {{ condition.values }}
                </span>
              </p>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <div class="expanded-view-btn">
          <el-row :type="'flex'" style="">
            <el-button class="float-right green-btn" size="medium" @click="editAllowlist">Edit</el-button>
            <el-button class="ml-16 float-right green-btn" size="medium" @click="copyAllowlist">Duplicate</el-button>
            <div class="divider"></div>
            <el-button class="float-right green-btn" size="medium" @click="removeAllowlist(details)">Delete</el-button>
            <!-- <el-button class="ml-16 float-right green-btn" size="medium">Pause</el-button> -->
          </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ALLOWLIST_DELETE_REQ, ALLOWLIST_EDIT_COPY_SET } from '@/store/modules/rules/rules.type'

export default {
  name: 'ExpandAllowlistDetails',
  props: {
    details: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      initialVisibleCount: 10,
      showAllRules: false
    }
  },
  methods: {
    removeAllowlist (details) {
      let vm = this
      let message = `Are you sure you want to delete this allowlist?`
      this.$confirm(message, 'Confirm Action', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        callback: function (action) {
          if (action === 'confirm') {
            vm.$store.dispatch(ALLOWLIST_DELETE_REQ, details.id).then(resp => {
              vm.$emit('delete-allowlist', details.id);
              vm.$message({
                type: 'success',
                message: `Allowlist ${details.name} deleted successfully`
              })
            }, _ => {
              vm.$message({
                type: 'success',
                message: `Error deleting ${details.name} allowlist`
              })
            })
          } else if (action === 'cancel') {
            vm.$message({
              type: 'info',
              message: `Operation canceled`
            })
          }
        }
      })
    },
    copyAllowlist () {
      this.$store.dispatch(ALLOWLIST_EDIT_COPY_SET, { operation: 'copy', allowlist: this.details })
      this.$router.push({
        name: 'duplicate-allowlist'
      })
    },
    editAllowlist () {
      this.$store.dispatch(ALLOWLIST_EDIT_COPY_SET, { operation: 'edit', allowlist: this.details })
      this.$router.push({
        name: 'edit-allowlist'
      })
    },
    getRule (ruleId) {
      return _.find(this.allRulesList, {
        id: ruleId
      })
    }
  },
  computed: {
    ...mapGetters(['allRulesList']),
    countText() {
      return `${this.visibleRules.length} of ${this.details.rules.length}`
    },
    visibleRules() {
      if (this.details.rules <= this.initialVisibleCount) {
        return this.details.rules;
      } else if (this.showAllRules) {
        return this.details.rules;
      } else {
        return this.details.rules.slice(0, this.initialVisibleCount);
      }
    }
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.material-icons {
  font-size: 1.3em;
  line-height: 36px;
  vertical-align: middle;
  color: var(--gray-500);
  background: transparent;
}

.el-divider--vertical {
  margin: 0px;
}

>>> .el-button {
  background-color: var(--aluminum-800);
  color: white;
}

.footer-buttons {
  &.center {
    margin: auto;
  }
}

.nowrap {
  white-space: nowrap;
}

.expanded-view {
  display: flex;
  width: 100%;
  background-color: #F8FCFF;
  padding-top: 2%;
}

.green-btn {
  background-color: #77DAB4;
}

.rules-container {
  margin: 0 51px 0 73px;
  width: 24%;
}

.rules-heading {
  width: 94px;
  color: #292C32;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
}

.rules-list {
  width: 300px;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
}

.conditions-heading {
  width: 94px;
  color: #292C32;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 20px;
}

.conditions-list {
  width: 323px;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
}

.divider {
  border-left: 1px solid black;
  height: 28px;
  margin: 3px 22px;
}

.text-btn {
  background: none;
  color: #409EFF;
}

.expanded-view-btn {
  position: absolute;
  top: 4%;
  right: 0%;
  margin-right:42px;
  margin-top: 32px;
}

>>> .el-button.ml-16 {
  margin-left: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/expand/ExpandAllowlistDetails.vue